import {
  ISourceEntityRecord,
  type IPracticeMigration,
  type ISource,
  SourceEntityRecordMigrationStatus,
} from '@principle-theorem/practice-migrations/interfaces';
import { setMigratedDestination } from '@principle-theorem/principle-db-connector';
import { PrimaryKey, type WithRef } from '@principle-theorem/shared';
import type { Knex } from 'knex';
import { PracticeMigration } from '../../practice-migrations';
import { getConfigurationItem } from '../../source/source';

export function getDatabaseConnectionName(source: ISource): string {
  return getConfigurationItem(source, 'database connection name', '');
}

export function getDatabaseName(source: ISource): string {
  return getConfigurationItem(source, 'database name', '');
}

export function getDatabaseUsername(source: ISource): string {
  return getConfigurationItem(source, 'database username', '');
}

export function getDatabasePassword(source: ISource): string {
  return getConfigurationItem(source, 'database password', '');
}

export function getPostgresConnection(
  _migration: WithRef<IPracticeMigration>
): Knex {
  throw new Error('getPostgresConnection is not available in browser');
}

export interface ISourceDatabaseRequest {
  query: string;
  migration: WithRef<IPracticeMigration>;
}

export function runQuery<T>(
  migration: WithRef<IPracticeMigration>,
  query: string
): Promise<IQueryResult<T>> {
  return runDatabaseRequest<IQueryResult<T>>({
    migration,
    query,
  });
}

export interface IQueryResult<T> {
  rows: T[];
}

export function runDatabaseRequest<T = unknown>(
  _data: ISourceDatabaseRequest
): Promise<T> {
  throw new Error('runDatabaseRequest is not available in browser');
}

export class Postgres {
  // eslint-disable-next-line @typescript-eslint/require-await
  static async upsert<T extends object>(
    _migration: WithRef<IPracticeMigration>,
    _tableName: string,
    _data: T[]
  ): Promise<void> {
    throw new Error('Postgres.upsert is not available in browser');
  }

  static async setMigratedByDestination(
    migration: WithRef<IPracticeMigration>,
    destinationKey: string,
    sourceRef: PrimaryKey<ISourceEntityRecord>,
    status: SourceEntityRecordMigrationStatus = SourceEntityRecordMigrationStatus.Migrated
  ): Promise<void> {
    const dataConnect = await PracticeMigration.dataConnect(migration);
    await setMigratedDestination(dataConnect, {
      id: sourceRef,
      destinationKey,
      status,
    });
  }
}
